import { jsx as _jsx } from "react/jsx-runtime";
/* eslint-disable react-hooks/refs -- @todo se om dette kan fikses */
import React, { useEffect, useRef } from 'react';
import FrankensteinExpanderList, {} from '@helsenorge/designsystem-react/components/ExpanderList';
import SafeHTML from '@helsenorge/framework-utils/components/safe-html';
import PortableText from '../richtext';
import useScrollingElementList, { DELAY_BEFORE_SCROLLING_ON_LOAD_MS } from './useScrollingElementList';
/**
 * Versjon av ExpanderList som støtter å scrolle til elementer i listen etter innlasting av siden.
 */
const ExpanderList = ({ color, items }) => {
    const expanderRefList = useRef(items.map(() => React.createRef()));
    const { scrollToElementByIndex } = useScrollingElementList(expanderRefList);
    const activeId = decodeURI(window.location?.hash);
    useEffect(() => {
        if (activeId) {
            const index = items.findIndex(({ id }) => `#${id}` === activeId);
            if (index !== -1) {
                // Vi må vente litt før scrollingen starter slik at vi scroller til riktig sted
                setTimeout(() => {
                    scrollToElementByIndex(index);
                }, DELAY_BEFORE_SCROLLING_ON_LOAD_MS);
                // TODO: ExpanderList støtter ikke p.t. å åpne enkeltelementer i listen,
                // vi må derfor trigge et klikk på knappen i elementet som skal åpnes
                const button = expanderRefList.current[index].current?.querySelector('button');
                if (button) {
                    button.focus();
                    button.click();
                }
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [activeId]);
    return (_jsx(FrankensteinExpanderList, { color: color, renderChildrenWhenClosed: true, children: items.map(({ title, titleHtmlMarkup, content }, index) => (_jsx(FrankensteinExpanderList.Expander, { title: title, titleHtmlMarkup: titleHtmlMarkup, ref: expanderRefList.current[index], children: Array.isArray(content) ? (_jsx(PortableText, { value: content, backgroundColor: color })) : (content && _jsx(SafeHTML, { html: content, className: "rich-text" })) }, index))) }));
};
export default ExpanderList;
